function About() {
  return (
    <section id="about" className="about-section animated-about">
      <div className="container">

        <div className="section-header">
          <h2>About <span>VAIVIDHYA</span></h2>
          <p>
            A national-level technical event focused on
            Artificial Intelligence and Robotics.
          </p>
        </div>

        <div className="about-content">
          <p>
            VAIVIDHYA 2K26 is a futuristic tech fest designed to bring together
            innovators, developers, and technology enthusiasts under one roof.
            The event provides a platform to explore cutting-edge advancements
            in Artificial Intelligence and Robotics through competitions,
            workshops, and interactive sessions.
          </p>

          <p>
            Our goal is to encourage innovation, hands-on learning, and
            collaboration while preparing students for the rapidly evolving
            technological future.
          </p>
        </div>

      </div>
    </section>
  );
}

export default About;
